import { call, put, takeLatest } from 'redux-saga/effects';

import * as mapActions from './mapActions.js';
import { updateMapApiCall } from './mapAPI.js';

function* updateMapSaga({ payload }) {
  try {
    const { data } = yield call(updateMapApiCall, payload);
    yield put(mapActions.mapUpdateStore(data));
  } catch (error) {
    yield put(mapActions.mapUpdateError(error.Message ? error.Message : error.toString()));
  }
}

export function* mapWatcher() {
  yield takeLatest(mapActions.mapUpdateRequest.type, updateMapSaga);
}
